import React, { useEffect, useState } from "react";
import styled from "styled-components";

import PhoneInput from "react-phone-number-input";
import { useTranslate } from '@tolgee/react';
import { useConversationService } from "../../Context/ConversationsContext";

import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg"
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg"
import { ReactComponent as Close } from "../../Assets/iconsv2/generic/closeBtn.svg"
import { EMAIL, PHONE } from "../../Constants/constantValues";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import PrimaryButton from "../GenericComponents/PrimaryButton";
import { useNotify } from "../../Helpers/Notifications";


const AddNewChatContact = ({
  loadContacts,
  closeAction
}) => {
  const { addContact } = useConversationService();
  const initialValues = {
    firstName: "",
    lastName: "",
    phone: "",
    groupName: "",
    email: "",
  };
  const { setLoading } = useGenericComponentsStateService()
  const [phone, setPhone] = useState(initialValues.phone);
  const [inputValues, setInputValues] = useState(initialValues);
  const [addBtnDisabled, setAddBtnDisabled] = useState(true);
  const [toggle, setToggle] = useState(PHONE);
  const [fullName, setFullName] = useState("");
  const { notifySuccess, notifyError, notifyInfo } = useNotify();
  const { t } = useTranslate();


  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const addNewContact = (phone, email) => {
    setLoading(true);
    addContact(
      fullName,
      phone,
      email,
      function (response) {
        notifySuccess(t('profile.contact_added'));
        loadContacts();
        setLoading(false);
        closeAction && closeAction();
      },
      function (error) {
        notifyError(t('general.something_wrong'));
        console.log(error);
        setLoading(false);
      }
    );
  };

  const handleAddNewContact = () => {
    if (toggle === PHONE) {
      addNewContact(phone, null);
    }
    if (toggle === EMAIL) {
      addNewContact(null, inputValues.email);
    }
  };

  const isNameValid = () => {
    if (inputValues.firstName || inputValues.lastName) {
      return true;
    } else {
      return false;
    }
  };

  const isEmailValid = (email) => {
  const emailRegex =
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
  };



  const checkDisabled = () => {
    if (toggle === PHONE) {
      if (phone?.length < 7 || !phone || !isNameValid()) {
        setAddBtnDisabled(true);
      } else {
        setAddBtnDisabled(false);
      }
    }

    if (toggle === EMAIL) {
      if (!isEmailValid(inputValues.email) || !isNameValid()) {
        setAddBtnDisabled(true);
      } else {
        setAddBtnDisabled(false);
      }
    }
  };

  useEffect(() => {
    setFullName(inputValues.firstName + " " + inputValues.lastName);
  }, [inputValues.firstName, inputValues.lastName]);

  useEffect(() => {
    checkDisabled();
  }, [phone, inputValues, toggle]);

  return (
    <AddNewGroupContainer>
      <Header>
        <HeaderTitle>{t('new_chat.new_contact')}</HeaderTitle>
        {closeAction &&
          <CloseButton onClick={() => closeAction()}>
            <Close />
          </CloseButton>
        }
      </Header>
      <CardInputsWrapper>
        <Group>
          <TitleWrapper>
            <h1>{t('general.name').toUpperCase()}</h1>
          </TitleWrapper>
          <CustomInput
            name="firstName"
            id="firstName-input"
            placeholder={t('general.first_name')}
            value={inputValues.firstName}
            onChange={(e) => inputChangeHandler(e)}
            maxLength={100}
          />

          <CustomInput
            name="lastName"
            id="lastName-input"
            placeholder={t('general.last_name')}
            value={inputValues.lastName}
            onChange={(e) => inputChangeHandler(e)}
            maxLength={100}
          />
        </Group>

        <Group style={{ alignItems: "center" }}>
          <ToggleContainer>
            <ToggleButton
              selected={toggle === PHONE}
              onClick={(e) => setToggle(PHONE)}
            >
              {toggle === PHONE ? <CheckedWrapper>
                <Check />
              </CheckedWrapper> :
                <CheckEmptyWrapper>
                  <CheckEmpty />
                </CheckEmptyWrapper>}
              {t('profile.phone')}
            </ToggleButton>
            <ToggleButton
              selected={toggle === EMAIL}
              onClick={(e) => setToggle(EMAIL)}
            >
              {toggle === EMAIL ? <CheckedWrapper>
                <Check />
              </CheckedWrapper> :
                <CheckEmptyWrapper>
                  <CheckEmpty />
                </CheckEmptyWrapper>}
              {t('profile.email')}
            </ToggleButton>
          </ToggleContainer>
        </Group>
        {toggle === PHONE && (
          <Group>
            <TitleWrapper>
              <h1>{t('profile.phone_number')}</h1>
            </TitleWrapper>
            <CustomPhoneWrapper>
              <PhoneInput
                showDropdown={false}
                international
                defaultCountry={"RO"}
                name="phoneNumber"
                placeholder={t('profile.phone_number')}
                value={phone}
                onChange={(e) => setPhone(e)}
                buttonClass="inputClass"
                dropdownClass="inputClass"
                containerClass="inputClass"
                limitMaxLength
              />
            </CustomPhoneWrapper>
          </Group>
        )}
        {toggle === EMAIL && (
          <Group>
            <TitleWrapper>
              <h1>{t('profile.email')}</h1>
            </TitleWrapper>
            <CustomInput
              name="email"
              id="email-input"
              placeholder={t('new_chat.email_placeholder')}
              value={inputValues.email}
              onChange={(e) => inputChangeHandler(e)}
              maxLength={100}
            />
          </Group>
        )}
        <Group>
          <PrimaryButton
            style={{ padding: "16px" }}
            disabled={addBtnDisabled}
            onClick={() => handleAddNewContact()}
          >
            {t('new_chat.add_contact')}
          </PrimaryButton>
        </Group>
      </CardInputsWrapper>
    </AddNewGroupContainer>
  );
};

export default AddNewChatContact;

const AddNewGroupContainer = styled.div`
 background: ${({ theme }) => theme.chat.conversationBackground};
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  margin:auto;
  overflow: auto;

`;

const CardInputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding:0 16px;
  margin:0 auto;
  width:100%;
      max-width:600px;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

`;

const CustomInput = styled.input`
  background: ${({ theme }) => theme.menu.groupContentBackground};
  padding: 14px 16px;
  border-radius: 4px;
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  width: 100%;
  border: none;
  &:focus {
    outline: none;
  }
  &::placeholder {
    font-weight: 400;
  }
`;

const CustomPhoneWrapper = styled.div`
 background: ${({ theme }) => theme.menu.groupContentBackground};
  padding: 0 0 0 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 100%;

   input {
    padding: 14px 16px;
     color: ${({ theme }) => theme.menu.primaryTextColor};
     background: ${({ theme }) => theme.menu.groupContentBackground};
    border-radius: 10px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
      outline: none;
    }
  }


  .PhoneInputCountry {
    border: none;
    background: ${({ theme }) => theme.chat.selectedBackground};
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    align-self: center;
    margin-right: 0;
  }
    .PhoneInput {
    width: 100%;
  }
  .PhoneInputCountrySelectArrow {
    display: none;
  }
  .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
   color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
  }
`;






const Header = styled.div`
display:flex;
justify-content:space-between;
padding: 19px 16px;
align-items:center;
background:${({ theme }) => theme.menu.conversationBackground};
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};
gap:20px;
`
const HeaderTitle = styled.h3`
font-weight: 700;
font-size: 20px;
line-height:32px;
letter-spacing: 0.04px;
color:${({ theme }) => theme.menu.primaryTextColor};
`


const ToggleContainer = styled.div`
display:flex;
align-items:center;
border-radius:4px;
overflow:hidden;
  background: ${({ theme }) => theme.menu.groupContentBackground};
border:1px solid ${({ theme }) => theme.toggleButton.borderColor};
width:100%;
`;

const ToggleButton = styled.button`
display:flex;
align-items:center;
gap:10px;
border:none;
background:${({ theme, selected }) => selected ? theme.primaryButton.background : "none"};
font-weight: 600;
font-size: 16px;
line-height: 18px;
color:${({ theme, selected }) => selected ? theme.primaryButton.color : theme.menu.toggleFadedColor};
padding:8px;
width:100%;
justify-content:center;
min-width:120px;
cursor:pointer;

svg{
height:20px;
fill:transparent;
color:transparent;
}
`
const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-left:auto;
  svg{
  height:26px;
  width:26px;
  color:${({ theme }) => theme.menu.selectedOpionBackground};
stroke:${({ theme }) => theme.sidebar.borderColor};
  }
`;
const CheckedWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.background};
fill:${({ theme }) => theme.check.checkSign};
}
`

const CheckEmptyWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.border};
stroke:${({ theme }) => theme.check.checkSign};
}
`